{
  "it": {
    "title": {
      "locations": {
        "index": "Luoghi",
        "places": "Tutti i luoghi"
      },
      "default": "FleetYards.net",
      "defaultShort": "FleetYards",
      "defaultAdmin": "FleetYards.net Command",
      "defaultAdminShort": "FltYrds Command",
      "defaultDocs": "FleetYards.net Documentation",
      "defaultDocsShort": "FleetYards Docs",
      "vehiclePlaque": "Targa di dedica di %{vehicle}",
      "home": "Home",
      "ships": {
        "index": "Navi",
        "viewer": "Ship Viewer"
      },
      "ship": "%{name} - %{manufacturer}",
      "shipImages": "%{name} Immagini",
      "shipVideos": "%{name} Video",
      "shipHistory": "Cronologia del %{name}",
      "componentHistory": "Cronologia di %{name}",
      "shipViewer": "%{name} Viewer",
      "images": "Immagini",
      "stats": "Statistiche",
      "login": "Accedi",
      "signUp": "Registrati",
      "embed": "Widget Incorporato",
      "apiV1": "API V1",
      "apiV1Schema": "Schema",
      "apiV1Pagination": "Paginazione",
      "authApiV1": "Auth API V1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schema",
      "hangar": {
        "index": "Il Mio Hangar",
        "preview": "Anteprima del Mio Hangar",
        "stats": "Statistiche del Mio Hangar",
        "import": "Importa",
        "public": "Hangar di %{user}",
        "publicStats": "Statistiche dell'Hangar di %{user}",
        "wishlist": "Lista dei desideri",
        "blueprints": "I miei progetti",
        "publicWishlist": "Lista dei desideri di %{user}",
        "vehicleLoadouts": "Loadouts della nave",
        "inventories": "My Hangar Inventories",
        "inventory": "%{inventory}",
        "vehicleCargo": "Carico della nave",
        "vehicleLoadout": "Loadout della nave",
        "buybacks": "Pledge riacquistabili",
        "paints": "Verniciature",
        "flair": "Decorazioni per l'hangar",
        "upgrades": "Potenziamenti / CCU",
        "equipment": "Equipaggiamento FPS",
        "imports": "Importazioni",
        "transfers": "Trasferimenti",
        "vehicleOverview": "Panoramica della nave",
        "vehicleLog": "Diario di bordo",
        "shipComponents": "Componenti di nave"
      },
      "requestPassword": "Richiedi la password",
      "changePassword": "Cambia la password",
      "fleets": {
        "add": "Crea una nuova Flotta",
        "preview": "Anteprima della Flotta",
        "invites": "Inviti Alla Flotta",
        "members": {
          "index": "%{fleet} Members",
          "invites": "%{fleet} Invites",
          "worldmap": "Mappa mondiale dei membri di %{fleet}",
          "starmap": "Mappa stellare dei membri di %{fleet}",
          "health": "Stato dei membri di %{fleet}"
        },
        "squadrons": {
          "index": "Squadroni di %{fleet}",
          "overview": "Panoramica dello squadrone di %{fleet}",
          "members": "Membri dello squadrone di %{fleet}",
          "create": {
            "details": "Crea squadrone - %{fleet}",
            "appearance": "Aspetto dello squadrone - %{fleet}",
            "discord": "Discord dello squadrone - %{fleet}"
          },
          "edit": {
            "details": "Modifica squadrone - %{fleet}",
            "appearance": "Aspetto dello squadrone - %{fleet}",
            "discord": "Discord dello squadrone - %{fleet}"
          }
        },
        "stats": "Statistiche di %{fleet}",
        "blueprints": "Progetti di %{fleet}",
        "logistics": {
          "index": "%{fleet} Logistics",
          "inventories": "%{fleet} Inventories",
          "transfers": "Trasferimenti di %{fleet}"
        },
        "missions": {
          "index": "Missioni di %{fleet}",
          "create": "Crea Missione - %{fleet}",
          "edit": {
            "details": "Modifica Missione - %{fleet}",
            "teams": "Modifica Team e Slot - %{fleet}"
          },
          "show": "Missione di %{fleet}"
        },
        "events": {
          "index": "Eventi di %{fleet}",
          "calendar": "Calendario di %{fleet}",
          "create": "Crea Evento - %{fleet}",
          "edit": {
            "details": "Modifica Evento - %{fleet}",
            "schedule": "Modifica Programmazione - %{fleet}",
            "signup": "Modifica Iscrizione - %{fleet}",
            "teams": "Modifica Team e Slot - %{fleet}"
          },
          "show": "Evento di %{fleet}",
          "payouts": "Pagamenti dell'evento di %{fleet}"
        },
        "tours": {
          "index": "Spedizioni di %{fleet}",
          "create": "Crea spedizione - %{fleet}",
          "show": "Spedizione di %{fleet}"
        },
        "settings": {
          "index": "Impostazioni di %{fleet}",
          "fleet": "Impostazioni di %{fleet}",
          "rsi": "%{fleet} – ID flotta e RSI",
          "membership": "Appartenenza a %{fleet}",
          "roles": "Ruoli di %{fleet}",
          "squadrons": "Squadroni di %{fleet}",
          "allies": "Alleati di %{fleet}",
          "notifications": "Impostazioni Notifiche di %{fleet}",
          "discord": "Impostazioni Discord di %{fleet}",
          "calendar": "Impostazioni Calendario di %{fleet}",
          "features": "Funzionalità di %{fleet}",
          "contracts": "Impostazioni contratti di %{fleet}"
        },
        "contracts": {
          "index": "Contratti",
          "create": "Crea contratto",
          "edit": "Modifica contratto",
          "show": "Contratto",
          "payouts": "%{fleet} Pagamenti del contratto"
        },
        "directory": "Directory delle flotte"
      },
      "roadmap": {
        "index": "Roadmap",
        "ships": "Roadmap Delle Navi",
        "changes": "Modifiche alla Roadmap"
      },
      "settings": {
        "index": "Impostazioni del Profilo",
        "profile": "Impostazioni profilo",
        "account": "Account",
        "hangar": "Impostazioni dell'Hangar",
        "privacy": "Impostazioni Privacy",
        "features": "Flag funzionalità",
        "connections": "Connessioni",
        "oauthApplications": "Applicazioni OAuth",
        "notifications": "Impostazioni Notifiche",
        "calendar": "Abbonamento al calendario",
        "donations": "Donazioni",
        "security": "Sicurezza dell'account",
        "twoFactor": {
          "enable": "Attiva Autenticazione A Due Fattori",
          "disable": "Disattiva Autenticazione A Due Fattori",
          "backupCodes": "Genera Codici Di Backup Autenticazione a Due Fattori"
        },
        "friends": "Amici"
      },
      "compare": {
        "ships": "Confronta Navi"
      },
      "notFound": "404",
      "tools": {
        "index": "Strumenti",
        "travelTimes": "Tempi di Viaggio",
        "cargoGrids": "Griglie di carico",
        "tradeRoutes": "Rotte commerciali",
        "tours": {
          "index": "Spedizioni",
          "add": "Crea una spedizione",
          "show": "%{tour}",
          "join": "Unisciti alla spedizione"
        }
      },
      "impressum": "Info legali",
      "support": "Sostieni",
      "share": "Condividi",
      "privacyPolicy": "Informativa sulla privacy",
      "cookiePolicy": "Informativa sui Cookie",
      "visualTests": {
        "blueprints": "Progetti - Test Visivi",
        "index": "Test Visivi",
        "panels": "Pannelli - Test Visivi",
        "buttons": "Pulsanti - Test Visivi",
        "events": "Eventi",
        "typography": "Tipografia - Test visivi",
        "forms": "Moduli - Test visivi",
        "tables": "Tabelle - Test Visivi",
        "lists": "Elenchi - Test visivi",
        "metrics": "Metriche - Test visivi",
        "states": "Stati - Test visivi",
        "notifications": "Notifiche - Test Visivi",
        "dedicationPlaques": "Targhe di dedica - Test Visivi",
        "syncModal": "Modal sincronizzazione - Test Visivi",
        "buybackSyncModal": "Modale sincronizzazione riacquisti - Test Visivi",
        "rsiVerificationModal": "Modale verifica RSI - Test Visivi",
        "fleetRsiVerificationModal": "Modale verifica RSI della flotta - Test Visivi",
        "overlays": "Overlay - Test Visivi",
        "installPrompt": "Invito all'installazione - Test Visivi",
        "supportHint": "Suggerimento supporto - Test Visivi",
        "media": "Media - Test Visivi",
        "charts": "Grafici - Test Visivi",
        "themes": "Temi - Test Visivi",
        "alerts": "Avvisi - Test visivi",
        "verifiedBadges": "Badge di verifica - Test visivi",
        "chips": "Chips - Test Visivi",
        "squadrons": "Squadroni - Test Visivi",
        "notificationCenter": "Centro notifiche - Test Visivi"
      },
      "admin": {
        "locations": {
          "index": "Luoghi",
          "show": "%{location}"
        },
        "blueprints": {
          "index": "Progetti",
          "show": "%{blueprint}"
        },
        "missions": {
          "index": "Missioni",
          "show": "%{mission}"
        },
        "models": {
          "index": "Modelli",
          "new": "Nuovo Modello",
          "edit": {
            "index": "Modifica %{manufacturer} %{model}",
            "metrics": "Modifica metriche di %{manufacturer} %{model}",
            "prices": "Modifica prezzi di %{manufacturer} %{model}",
            "fleetchart": "Modifica immagini del grafico flotta di %{manufacturer} %{model}",
            "positions": "Modifica posizioni di %{manufacturer} %{model}",
            "hardpoints": "Modifica punti di montaggio di %{manufacturer} %{model}",
            "cargoAndFuel": "Modifica carburante di %{manufacturer} %{model}",
            "cargoHolds": "Modifica stive di carico di %{manufacturer} %{model}",
            "docks": "Modifica dock di %{manufacturer} %{model}",
            "modules": "Modifica moduli di %{manufacturer} %{model}",
            "paints": "Modifica verniciature di %{manufacturer} %{model}",
            "images": "Modifica immagini di %{manufacturer} %{model}",
            "videos": "Modifica video di %{manufacturer} %{model}",
            "loaners": "Modifica prestiti di %{manufacturer} %{model}",
            "snubCrafts": "Modifica Snub Craft di %{manufacturer} %{model}",
            "upgrades": "Modifica miglioramenti di %{manufacturer} %{model}",
            "packages": "Modifica pacchetti di %{manufacturer} %{model}",
            "history": "Modifica cronologia di %{manufacturer} %{model}"
          }
        },
        "components": {
          "index": "Componenti",
          "new": "Nuovo Componente",
          "edit": {
            "index": "Modifica componente",
            "prices": "Edit Component Prices",
            "history": "Modifica cronologia del componente"
          }
        },
        "manufacturers": {
          "index": "Produttori",
          "new": "Nuovo Produttore",
          "edit": {
            "index": "Modifica Produttore"
          }
        },
        "announcements": {
          "index": "Annunci",
          "new": "Nuovo annuncio",
          "edit": "Modifica annuncio",
          "show": "Annuncio"
        },
        "supporterContributions": {
          "index": "Contributi dei sostenitori",
          "new": "Nuovo contributo",
          "edit": "Modifica contributo"
        },
        "fundingGoals": {
          "index": "Obiettivi di finanziamento",
          "new": "Nuovo obiettivo di finanziamento",
          "edit": "Modifica obiettivo di finanziamento"
        },
        "homepage": "Pagina iniziale",
        "gameEvents": {
          "index": "Eventi di gioco",
          "new": "Nuovo evento di gioco",
          "edit": "Modifica evento di gioco"
        },
        "users": {
          "index": "Utenti",
          "edit": "Modifica Utente",
          "inventories": "Inventari dell'utente",
          "inventory": "Inventario dell'utente",
          "inventoryItem": "Voce di inventario",
          "fleets": "Flotte dell'utente",
          "supporterContributions": "Contributi del sostenitore"
        },
        "vehicles": {
          "index": "Veicoli",
          "edit": "Modifica Veicolo"
        },
        "admins": {
          "index": "Amministratori",
          "new": "Nuovo Admin",
          "edit": "Modifica Admin"
        },
        "fleets": {
          "index": "Flotte",
          "edit": "Modifica Flotta",
          "members": "Membri della flotta",
          "memberEdit": "Modifica membro della flotta",
          "history": "Cronologia della flotta",
          "roles": "Ruoli della flotta",
          "role": "Ruolo della flotta",
          "inventories": "Inventari della flotta",
          "inventory": "Inventario della flotta",
          "inventoryItem": "Voce di inventario"
        },
        "oauthApplications": {
          "index": "Applicazioni OAuth",
          "new": "Nuova applicazione OAuth",
          "edit": "Modifica applicazione OAuth"
        },
        "features": {
          "index": "Flag funzionalità",
          "show": "Dettagli funzionalità",
          "overview": "Flag funzionalità",
          "users": "Utenti del flag",
          "fleets": "Flotte del flag",
          "history": "Cronologia del flag"
        },
        "images": {
          "index": "Immagini"
        },
        "notifications": {
          "index": "Notifiche"
        },
        "maintenance": {
          "index": "Manutenzione",
          "pghero": "PgHero",
          "features": "Funzionalità",
          "flipper": "Flipper UI",
          "workers": "Workers",
          "tasks": "Attività",
          "imports": "Importazioni",
          "importDetail": "Dettaglio importazione",
          "rsiApiStatus": "Stato API RSI",
          "buildCompare": "Confronto build"
        },
        "modelPaints": {
          "index": "Verniciature Modelli",
          "edit": "Modifica Verniciatura Modello"
        },
        "modelModules": {
          "index": "Moduli Modelli",
          "edit": {
            "index": "Modifica %{name} Dati Base",
            "models": "Modifica %{name} Modelli",
            "prices": "Modifica %{name} Prezzi",
            "hardpoints": "Modifica Hardpoint di %{name}",
            "docks": "Modifica dock di %{name}",
            "cargoHolds": "Modifica stive di carico di %{name}",
            "history": "Modifica cronologia del modulo"
          }
        },
        "unlistedModels": {
          "index": "Navi non elencate"
        },
        "modelModulePackages": {
          "index": "Pacchetti Moduli Modelli"
        },
        "commodities": {
          "index": "Commodities",
          "new": "New Commodity",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "new": "New Equipment",
          "edit": {
            "index": "Edit Equipment",
            "prices": "Edit Equipment Prices"
          }
        },
        "visualTests": {
          "index": "Test Visivi",
          "notifications": "Notifiche - Test Visivi"
        }
      },
      "notifications": "Notifiche",
      "component": "%{name}",
      "commodity": "%{name}",
      "commodities": {
        "index": "Merci"
      },
      "components": {
        "index": "Componenti"
      },
      "blueprints": {
        "index": "Progetti"
      },
      "missions": {
        "index": "Missioni"
      },
      "equipment": {
        "index": "Equipaggiamento"
      },
      "equipmentItem": "%{name}"
    }
  }
}
